module.exports = "<button *ngIf=\"showBtn\"\r\n  type=\"button\"\r\n  class=\"ico-check m-btn m-btn-circle m-btn-circle-x-small m-btn-danger\">\r\n  <i class=\"icofont-ui-close\"></i>\r\n</button>\r\n\r\n<div *ngIf=\"!showBtn\">{{params.value}}</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/grid-components/standing-order-render/standing-order-render.component.html
// module id = 2336
// module chunks = 66